import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AdminData, AdminState, BaseUser } from "./index.types";

const initialState: AdminState = {
  isAdminLoading: false,
  isAdminUpdateLoading: false,
  adminData: {},
  adminUpdateSuccess: false,
  isRoleUpdateInprogress: false,
  userRoleUpdated: false,
};

const name = "admin";

export const adminSlice = createSlice({
  name,
  initialState,
  reducers: {
    getAdmin: (state) => {
      state.isAdminLoading = true;
    },
    updateAdminInfo: (state) => {
      state.isAdminUpdateLoading = true;
    },
    updateAdminInfoSuccess: (state) => {
      state.isAdminUpdateLoading = false;
      state.adminUpdateSuccess = false;
      state.adminUpdateSuccess = true;
    },
    updateAdminInfoFail: (state, action: PayloadAction<any>) => {
      state.isAdminUpdateLoading = false;
      state.adminUpdateSuccess = false;
      action.payload && toast.error("Request failed with status 400(Bad Request)");
    },
    updateUserRole: (state) => {
      state.isRoleUpdateInprogress = true;
    },
    updateUserRoleSuccess: (state) => {
      state.isRoleUpdateInprogress = false;
      state.userRoleUpdated = true;
    },
    updateUserRoleFail: (state, action: PayloadAction<any>) => {
      state.isRoleUpdateInprogress = false;
      state.userRoleUpdated = false;
      action.payload && toast.error("Request failed with status 400(Bad Request)");
    },

    getAdminSuccess: (state, action: PayloadAction<AdminData>) => {
      state.isAdminLoading = false;
      state.adminUpdateSuccess = false;
      state.adminData = action.payload;
    },
    getAdminFail: (state) => {
      state.isAdminLoading = false;
      state.adminData = {};
    },
    softClearUpdateStatuses: (state) => {
      state.isAdminUpdateLoading = false;
      state.adminUpdateSuccess = false;
    },
    clearAdminStatuses: (state) => {
      state.isAdminLoading = false;
      state.isAdminUpdateLoading = false;
      state.adminUpdateSuccess = false;
      state.adminData = {};
    },
  },
});

export const { getAdmin, clearAdminStatuses, softClearUpdateStatuses } = adminSlice.actions;

export default adminSlice.reducer;

export const getAdminInfo = (userId: string | number) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/users/${userId}/`,
  },
  type: "getAdmin",
});

export const updateAdminInfo = (userId: string | number, data: BaseUser | FormData) => ({
  payload: {
    apiName: name,
    data,
    formData: true,
    method: "PATCH",
    url: `/api/users/${userId}/`,
  },
  type: "updateAdminInfo",
});

export const updateUserRole = (userId: string | number, data: BaseUser | FormData) => ({
  payload: {
    apiName: name,
    data,
    method: "POST",
    url: `/api/users/${userId}/groups/`,
  },
  type: "updateUserRole",
});
